import services from './components/services.vue';
import clients from './components/clients.vue';
import company from './components/company.vue';
import contactform from './components/contactform.vue';
import homepage from './components/homepage.vue';

export const routes = [
  { name: 'Homepage', path: '', component: homepage },
  { name: 'Services', path: '/services', component: services },
  { name: 'Clients', path: '/clients', component: clients },
  { name: 'Company', path: '/company', component: company },
  { name: 'Contact Us', path: '/get-in-touch', component: contactform },
  { name: 'Start a Project', path: '/start-a-project', component: contactform },
  { name: 'Request Case Study', path: '/request-case-study', component: contactform }
];



// WEBPACK FOOTER //
// ./src/routes.js